import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import { fullScreenPlugin } from '@react-pdf-viewer/full-screen'
import { toolbarPlugin, ToolbarProps, TransformToolbarSlot } from '@react-pdf-viewer/toolbar'
import React, { useEffect, useState } from 'react'
// @ts-ignore
import pdfWorker from '../../assets/workers/pdf.worker.min.txt'

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

interface P {
    file: string | Blob
}

export default function PDFViewer({ file }: P) {
    if (!file) return

    const [fileUrl, setFileUrl] = useState<string>('')

    useEffect(() => {
        if (typeof file === 'string') {
            setFileUrl(file)
        } else {
            const url = URL.createObjectURL(file)
            setFileUrl(url)
            return () => {
                URL.revokeObjectURL(url)
            }
        }
    }, [file])

    useEffect(() => {
        if (typeof file === 'string') {
            setFileUrl(file)
        } else {
            const url = URL.createObjectURL(file)
            setFileUrl(url)
            return () => {
                URL.revokeObjectURL(url)
            }
        }
    }, [file])

    const fullScreenPluginInstance = fullScreenPlugin()
    const toolbarPluginInstance = toolbarPlugin()
    const { renderDefaultToolbar } = toolbarPluginInstance
    const transform: TransformToolbarSlot = slot => ({
        ...slot,
        SwitchTheme: () => <></>,
        SwitchThemeMenuItem: () => <></>,
        Open: () => <></>,
        Print: () => <></>,
        Rotate: () => <></>,
        ShowProperties: () => <></>,
        SwitchSelectionMode: () => <></>
    })
    const renderToolbar = (Toolbar: (props: ToolbarProps) => React.ReactElement) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    )
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        sidebarTabs: () => [],
        renderToolbar,
        toolbarPlugin: {
            fullScreenPlugin: {
                onEnterFullScreen: zoom => zoom(SpecialZoomLevel.PageFit),
                onExitFullScreen: zoom => zoom(SpecialZoomLevel.PageFit),
                getFullScreenTarget: pagesContainer =>
                    pagesContainer.closest('[data-testid="default-layout__main"]'),
                renderExitFullScreenButton: () => <></>
            }
        }
    })

    return (
        <Worker workerUrl={pdfWorker}>
            <div style={{ height: '100%', width: '100%' }}>
                <Viewer
                    fileUrl={fileUrl}
                    plugins={[defaultLayoutPluginInstance as any, fullScreenPluginInstance as any]}
                />
            </div>
        </Worker>
    )
}
